export default {
  profile: {
    welcomeBack: 'Welcome back, {{name}}',
    viewYourShop: 'View your shop',
    customizeYourProfile: 'Customize your profile',
  },
  earnings: {
    youveEarnedHtml: 'You\'ve earned %{tagOpen}%{totalEarnings}%{tagClose} on Reverb',
    fromReverbProtections: '%{tagOpen}%{accommodationsTotal}%{tagClose} from Reverb Protections or Safe Shipping Programs',
  },
  timePeriods: {
    this_month: 'this month',
    last_month: 'last month',
    days_7: 'in the last 7 days',
    months_3: 'in the last 3 months',
    months_6: 'in the last 6 months',
    months_12: 'in the last year',
  },
  shopStats: {
    shopEngagement: 'Shop Engagement',
    comparedToPrevious: '{{startDate}} - {{endDate}} compared to the previous period',
    orders: 'Orders',
    offers: 'Offers',
    messages: 'Messages',
    watchers: 'Watchers',
    noChange: 'no change',
    sellerRatingShopStat: {
      reviewsFromBuyers: '{{strongOpen}}{{total}}{{strongClose}} reviews from buyers',
      percentPositive: '{{ratingPercent}}% positive',
    },
  },
  bumpStats: {
    title: 'Bumped Listings',
    usedTitle: 'Used Listings',
    brandNewTitle: 'New Listings',
    spent: 'Spent',
    sales: 'Sales',
    percentageSpent: 'Bump Spend %',
    views: 'Bump Views',
  },
  recentOrders: {
    mostRecentOrders: 'Most recent orders',
    viewAllOrders: 'View All Orders',
    printLabel: 'Print Label',
    getALabel: 'Get a Label',
    addTracking: 'Add Tracking',
  },
  recentOffers: {
    mostRecentOffers: 'Most recent offers',
    viewAllOffers: 'View All Offers',
    offer: 'Offer: ',
    counterOffer: 'Counter offer: ',
    from: 'from {{name}}',
    in: 'in {{address}}',
    expired: 'Expired',
    expires: 'Expires {{time}}',
    respond: 'Respond',
  },
  recentMessages: {
    mostRecentMessages: 'Most recent messages',
    viewAllMessages: 'View All Messages',
    unread: 'unread',
    respond: 'Respond',
  },
  recommendedPriceDrops: {
    priceYourGear: 'Price your gear to sell',
    competitivelyPricedGear: 'Competitively priced gear sells fast on Reverb. Find the right price with the %{linkOpen}Reverb Price Guide%{linkClose}.',
    viewAll: 'View all listings priced above average',
    priceDropItem: {
      mostLikelyToSell: 'Most likely to sell for {{price}} or less',
      editPrice: 'Edit Price',
      success: 'Price successfully updated',
    },
  },
  recommendedDirectOffers: {
    sendDealsWith: 'Send deals with direct offers',
    engageWatchers: 'Engage watchers and other interested buyers by setting up automated %{linkOpen}direct offers%{linkClose}.',
    viewAll: 'View all listings with direct offers tips',
    directOfferItem: {
      buyersWatching: '{{watcherCount}} buyers watching ',
      enableDirectOffers: 'Enable Direct Offers',
      manageDirectOffers: 'Manage Direct Offers',
      success: 'Direct offers enabled',
    },
  },
  draftListings: {
    readyToSell: 'Ready to sell again?',
  },
};
